module.exports = __webpack_public_path__ + "img/style_1_0.a841f663.png";